class ProductVariantDropdown extends HTMLElement {
  #button = this.querySelector('button');
  #selectedValueEl = this.querySelector('[data-selected-value]');

  connectedCallback() {
    this.#updateButtonLabel();

    this.#button.addEventListener('click', (event) => {
      event.preventDefault();
      this.classList.toggle('active');
    });

    document.addEventListener('click', (event) => {
      if (!this.contains(event.target)) this.classList.remove('active');
    });

    this.addEventListener('change', (event) => {
      const input = event.target.closest('input[type="radio"]');
      if (!input) return;
      if (this.#selectedValueEl) this.#selectedValueEl.textContent = input.value;
      this.classList.remove('active');
    });
  }

  #updateButtonLabel() {
    const checked = this.querySelector('input[type="radio"]:checked');
    if (checked && this.#selectedValueEl) {
      this.#selectedValueEl.textContent = checked.value;
    }
  }
}

customElements.define('variant-dropdown', ProductVariantDropdown);
